// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__3XOxA","paramInput":"JobSimulator_paramInput__2wov2","input":"JobSimulator_input__1xATE"};